<i18n lang="yaml">
  pt:
    visitStore: "Visite a Loja"
    production: "No link oficial"
    test: "No ambiente de teste"
</i18n>

<template>
  <header class="mainheader p-relative">
    <div
      data-grid
      class="mainheader__wrapper grid--va-center p-4"
    >
      <CustomProductsSelection />

      <div
        class="visit-store text-uppercase p-relative ms-auto"
        data-grid="column"
      >
        <DefaultButton class="visit-store__button text-uppercase ms-auto">
          <StoreIcon />

          <span class="visit-store__label">
            {{ $t('visitStore') }}
          </span>
        </DefaultButton>

        <ul class="visit-store__list p-absolute p-3">
          <li class="item w-100">
            <a
              :href="prodURL"
              target="_blank"
              data-grid="nowrap"
            >
              {{ $t('production') }}

              <ArrowTopRightSquareIcon class="ms-1" />
            </a>
          </li>

          <li class="item w-100">
            <a
              target="_blank"
              data-grid="nowrap"
              :href="testURL"
            >
              {{ $t('test') }}

              <ArrowTopRightSquareIcon class="ms-1" />
            </a>
          </li>
        </ul>
      </div>

      <HelpDropdown class="mainheader__help ms-3" />

      <div class="vertical-divider" />

      <UserApp />

      <figure class="mainheader__logo p-absolute m-0 p-0 h-100 overflow-hidden opacity-5">
        <img
          alt="Increazy Dash"
          :src="require('@/assets/images/dash-square-light.webp')"
        >
      </figure>
    </div>
  </header>
</template>

<script>
import { defineComponent } from 'vue'

import UserApp from '../components/UserApp.vue'
import StoreIcon from '../../../icons/StoreIcon'
import DefaultButton from '../../../global/Button'
import HelpDropdown from '../../../global/HelpDropdown'
import CustomProductsSelection from '../../custom-products-selection'
import ArrowTopRightSquareIcon from '../../../icons/ArrowTopRightSquareIcon'

export default defineComponent({
  name: 'HeaderMain',

  components: {
    UserApp,
    StoreIcon,
    HelpDropdown,
    DefaultButton,
    CustomProductsSelection,
    ArrowTopRightSquareIcon
  },

  computed: {
    prodURL () {
      const url = this.$app?.url

      if (!url) return ''

      return !url
        ? ''
        : url.replace(/http(s)?/i, 'https')
    },

    testURL () {
      return `${this.prodURL.replaceAll('.', '_')}.lab.increazy.com`
    },

    isInProduction () {
      return !process.env.VUE_APP_BACKEND_API.includes('test')
    }
  }
})
</script>

<style lang="scss" scoped>
  .mainheader {
    z-index: 25;
    background: linear-gradient(90.89deg, var(--primary) 0%, var(--primary-light) 99.79%);

    .is-dark-theme & {
      background: rgb(var(--black2)) !important;
    }

    &__wrapper {
      height: var(--header-height);
    }

    &__logo {
      top: 0;
      right: 16px;

      z-index: -1;
      max-width: 140px;
      pointer-events: none;
      mask-image: linear-gradient(to bottom, rgb(var(--black)), rgba(0,0,0,0.1));

      img {
        margin-block: 16px 0;
      }

      .is-dark-theme & {
        opacity: .1;
      }
    }

    &__help {
      color: var(--primary);
      width: 40px;
      height: 40px;
      background-color: rgb(var(--white));

      .is-dark-theme & {
        color: rgb(var(--white));
      }

      :deep(svg) {
        width: 50%;
        height: 50%;
      }
    }

    .vertical-divider {
      width: 1px;
      height: 100%;

      opacity: 0.5;
      margin: 0 calc(var(--gap) * 2);
      background-color: rgba(var(--white), 0.4);

      .is-dark-theme & {
        background-color: rgba(var(--white), 0.05);
      }
    }

    .visit-store {
      --bgColor: var(--primary);
      overflow: unset;
      width: max-content;

      .is-dark-theme & {
        --bgColor: rgb(var(--gray8)) !important;

        color: rgb(var(--white));
      }

      .defaultbutton {
        font-size: 1.3rem;
        background-color: var(--bgColor);

        svg {
          width: 20px;
          height: 20px;
        }
      }

      &:hover .visit-store__list {
        top: 45px;
        opacity: 1;
        visibility: visible;

        a {
          color: inherit;
        }
      }

      &__list {
        right: 0;
        top: 10px;
        border-radius: 7px;
        background-color: rgb(var(--white));
        box-shadow: 0 0 15px -3px rgba(0, 0, 0, .1);
        width: max-content;
        max-width: 300px;
        opacity: 0;
        visibility: hidden;
        transition: all .4s;

        .is-dark-theme & {
          background-color: rgb(var(--gray8)) !important;
          color: rgb(var(--white));
        }

        .item {
          align-items: center;

          &:not(:last-child) {
            margin-bottom: 5px;
          }

          a {
            font-size: 1.3rem;
            color: rgb(var(--white));
            text-transform: initial;

            svg {
              width: 15px;
              color: var(--primary);
            }
          }
        }
      }
    }

    @media (max-width: 1024px) {
      .visit-store {
        &__button {
          padding: 0;
          width: 40px;
          height: 40px;

          svg {
            margin: 0;
          }
        }

        &__label {
          display: none;
        }
      }

      &__help,
      .vertical-divider {
        display: none;
      }
    }
  }
</style>
